
/**
 * 주문 상태
 */
export type GetOrderInfo200Status = typeof GetOrderInfo200Status[keyof typeof GetOrderInfo200Status];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderInfo200Status = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
